<template>
  <b-card class="shadow atm-rounded h-100">
    <section v-if="checklistProgressSummary">
      <table class="table table-bordered table-responsive">
        <thead>
          <tr>
            <th class="w-75 text-center">
              <b-card-title>Checklist progress summary</b-card-title>
            </th>
            <th
              class="w-25 text-center"
              v-for="(label, index) in labelsForTheTableHeader"
              :key="index"
            >
              <p class="m-0">{{ label }}</p>
            </th>
          </tr>
        </thead>
        <tbody class="body-table">
          <tr v-for="(module, index) in checklistProgressSummary" :key="index">
            <td>
              <b-img :src="module.icon" class="coinImg mr-2" />
              {{ module.name }}
            </td>
            <td
              class="text-center"
              :class="{ 'average-success': getNumberFromAverage(module.checkItems.average) >= 80 }"
            >
              {{ module.checkItems.average }}
            </td>
            <td class="text-center">{{ module.personalBest.average }}</td>
            <td class="text-center">{{ module.checked }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </b-card>
</template>

<script>
export default {
  props: {
    checklistProgress: Array,
  },
  data() {
    return {
      labelsForTheTableHeader: ['Average % of criteria', 'Personal best', '# Checked'],
      checklistProgressSummary: [],
    };
  },
  methods: {
    getNumberFromAverage(average) {
      return Number(average.replace('%', ''));
    },
  },
  watch: {
    checklistProgress: {
      handler(newVal) {
        if (newVal) this.checklistProgressSummary = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.body-table {
  font-size: 14px;
}
.column-width {
  width: 150px;
}
.average-success {
  color: var(--accepted);
}
</style>
